import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "_change-status _modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = {
  key: 0,
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M29.8034 3.38292C15.2228 3.38292 3.36674 15.3238 3.36674 30.001C3.36674 44.6762 15.2228 56.6171 29.8034 56.6171C44.3839 56.6171 56.2452 44.6762 56.2452 30.001C56.2452 15.3238 44.3839 3.38292 29.8034 3.38292ZM29.8034 60C13.3737 60 0 46.5418 0 30.001C0 13.4582 13.3737 0 29.8034 0C46.2382 0 59.6068 13.4582 59.6068 30.001C59.6068 46.5418 46.2382 60 29.8034 60Z",
  fill: "#E37056"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M52.5556 30.0008C52.5556 42.6491 42.3702 52.9023 29.8016 52.9023C17.2381 52.9023 7.05273 42.6491 7.05273 30.0008C7.05273 17.3515 17.2381 7.09775 29.8016 7.09775C42.3702 7.09775 52.5556 17.3515 52.5556 30.0008Z",
  fill: "#F4C870"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M29.7892 36.6177C29.0372 36.6177 28.3904 36.8826 27.869 37.408C27.3527 37.9313 27.0869 38.5748 27.0869 39.3217C27.0869 40.1721 27.3677 40.8489 27.9242 41.3324C28.4606 41.8028 29.0973 42.041 29.8192 42.041C30.5311 42.041 31.1628 41.7993 31.6943 41.3228C32.2457 40.8323 32.5215 40.159 32.5215 39.3217C32.5215 38.5733 32.2508 37.9278 31.7193 37.4045C31.1879 36.8811 30.5362 36.6177 29.7892 36.6177Z",
  fill: "white"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  d: "M27.7136 31.5484V31.56C27.8088 32.5688 27.9743 33.3092 28.2049 33.8225C28.4907 34.4377 29.0171 34.7627 29.729 34.7627C30.4259 34.7627 30.9523 34.4326 31.2581 33.8073C31.5188 33.2739 31.6792 32.5471 31.7544 31.5882L32.4112 24.024C32.4864 23.3154 32.5215 22.6084 32.5215 21.923C32.5215 20.7012 32.361 19.7806 32.0352 19.1074C31.7845 18.5835 31.208 17.9602 29.9095 17.9602C29.0723 17.9602 28.3804 18.2454 27.859 18.8056C27.3476 19.3592 27.0869 20.1243 27.0869 21.0797C27.0869 21.71 27.1321 22.7567 27.2273 24.1941L27.7136 31.5484Z",
  fill: "white"
}, null, -1)
const _hoisted_8 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M29.8034 3.38292C15.2228 3.38292 3.36674 15.3238 3.36674 30.001C3.36674 44.6762 15.2228 56.6171 29.8034 56.6171C44.3839 56.6171 56.2452 44.6762 56.2452 30.001C56.2452 15.3238 44.3839 3.38292 29.8034 3.38292ZM29.8034 60C13.3737 60 0 46.5418 0 30.001C0 13.4582 13.3737 0 29.8034 0C46.2382 0 59.6068 13.4582 59.6068 30.001C59.6068 46.5418 46.2382 60 29.8034 60Z",
  fill: "#2AA797"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M52.5556 30.0008C52.5556 42.6491 42.3702 52.9023 29.8016 52.9023C17.2381 52.9023 7.05273 42.6491 7.05273 30.0008C7.05273 17.3515 17.2381 7.09775 29.8016 7.09775C42.3702 7.09775 52.5556 17.3515 52.5556 30.0008Z",
  fill: "#F0BB4F"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M27.6717 40.4004L19.4707 31.456L23.2608 27.9312L27.4092 32.4572L37.7092 19.6004L41.7224 22.8607L27.6717 40.4004Z",
  fill: "white"
}, null, -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5"
}
const _hoisted_15 = {
  key: 1,
  class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 3,
  class: "text-center text-neutral-500 mt-2"
}
const _hoisted_18 = {
  key: 4,
  class: "w-full mt-6 flex items-center justify-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-sm text-neutral-700" }, " Tôi đã hiểu, không cần lặp lại thông báo này ", -1)
const _hoisted_20 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (!_ctx.successfully)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_8))
          : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_13))
      ]),
      (!_ctx.successfully)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.isReTeach ? 'Không dạy mục tiêu này' : 'Xoá mục tiêu'), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, " Xoá mục tiêu thành công ")),
      (!_ctx.successfully)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "text-center text-neutral-500 mt-2",
            innerHTML: 
					_ctx.isReTeach
						? `Mục tiêu này sẽ được thêm trở lại vào phần <br/> ${_ctx.label} của học sinh`
						: `Mục tiêu này sẽ được xoá khỏi hệ thống`
				
          }, null, 8, _hoisted_16))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, " Mục tiêu này đã được xoá khỏi hệ thống ")),
      (!_ctx.successfully)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "flex items-center w-fit cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.noRepeat = !_ctx.noRepeat))
            }, [
              _createVNode(_component_Checkbox, { value: _ctx.noRepeat }, null, 8, ["value"]),
              _hoisted_19
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, _toDisplayString(_ctx.successfully ? 'Đóng' : 'Thoát'), 1),
      (!_ctx.successfully)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "button-p text-center whitespace-nowrap",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, " Xác nhận "))
        : _createCommentVNode("", true)
    ])
  ]))
}